// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CLSYjK5CMcm3k_zUxMn4{width:100%}.Olc6v2CsUIwoJAx5sUqP{position:relative}.ayuPXOyDLKwVxjetdKGw{height:16px;margin:-8px -3px}.zv0RZwO_VxYbUlWG0Rhl{position:relative}.y8TFsuP0aRYmt24IcC2Y{margin-bottom:27px}.y8TFsuP0aRYmt24IcC2Y:last-of-type{margin-bottom:0}.Dz1pVqeqggq96rvQ5GxJ{color:var(--content-negative-primary);align-items:center;margin-bottom:-9px;padding-top:5px;font-size:11px;font-weight:400;display:flex}.h12kK97AscM_MQeQFqVw{margin-right:5px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `CLSYjK5CMcm3k_zUxMn4`,
	"input": `Olc6v2CsUIwoJAx5sUqP`,
	"input__button": `ayuPXOyDLKwVxjetdKGw`,
	"inputButton": `ayuPXOyDLKwVxjetdKGw`,
	"input__wrap": `zv0RZwO_VxYbUlWG0Rhl`,
	"inputWrap": `zv0RZwO_VxYbUlWG0Rhl`,
	"section": `y8TFsuP0aRYmt24IcC2Y`,
	"error": `Dz1pVqeqggq96rvQ5GxJ`,
	"error__icon": `h12kK97AscM_MQeQFqVw`,
	"errorIcon": `h12kK97AscM_MQeQFqVw`
};
export default ___CSS_LOADER_EXPORT___;
